import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import FormComponent from '../../../Reusable_Components/FormComponent';
import { API_ROUTES, API_DOMAIN } from '../../../Reusable_Components/Config/apiConfig';

function buildHeaders() {
  const token = localStorage.getItem('customer_management_token');
  const tenantId = localStorage.getItem('crm_tenant_id');
  const tenantToken = localStorage.getItem('crm_tenant_token');
  return {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Token ${token}` } : {}),
    ...(tenantId ? { 'X-Tenant-ID': tenantId } : {}),
    ...(tenantToken ? { 'X-Tenant-Token': tenantToken } : {}),
  };
}

const CommunicationLogInput = () => {
  const { logId = '' } = useParams();
  const decodedId = logId ? atob(logId) : logId;
  const id = decodedId.replace(/\D/g, '');
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({});
  const [activities, setActivities] = useState([]);
  const [users, setUsers] = useState([]);
  const route = 'customerCommunicationLog';

  // Fetch activities and users fresh every mount (no cache)
  useEffect(() => {
    fetch(`${API_DOMAIN}${API_ROUTES.customerActivity}?page_size=200`, { headers: buildHeaders() })
      .then(r => r.ok ? r.json() : Promise.reject(r.status))
      .then(data => {
        const items = Array.isArray(data) ? data : (data.results || []);
        setActivities(items);
      })
      .catch(err => console.error('Failed to load activities:', err));

    fetch(`${API_DOMAIN}${API_ROUTES.users}?page_size=200`, { headers: buildHeaders() })
      .then(r => r.ok ? r.json() : Promise.reject(r.status))
      .then(data => {
        const items = Array.isArray(data) ? data : (data.results || []);
        setUsers(items);
      })
      .catch(err => console.error('Failed to load users:', err));
  }, []);

  useEffect(() => {
    if (!logId) return;
    setIsEditing(true);
    axios.get(`${API_DOMAIN}${API_ROUTES.customerCommunicationLog}${id}/`, { headers: buildHeaders() })
      .then(res => setFormData(res.data))
      .catch(err => console.error('Error fetching communication log details:', err));
  }, [logId, id]);

  const logFields = [
    { name: 'note', label: 'Note', type: 'textarea', required: true },
    {
      name: 'activity', label: 'Activity', type: 'select', required: true,
      options: activities.map(a => ({ value: a.id, label: a.subject || `Activity #${a.id}` })),
    },
    {
      name: 'logged_by', label: 'Logged By', type: 'select', required: true,
      options: users.map(u => ({ value: u.id, label: u.username || u.email || `User #${u.id}` })),
    },
  ];

  return (
    <div>
      <h1>{isEditing ? 'Edit Communication Log' : 'Create Communication Log'}</h1>
      <FormComponent fields={logFields} initialFormData={formData} route={route} cancelPath="/customer/communication-log/list" />
    </div>
  );
};

export default CommunicationLogInput;
